module.exports = __webpack_public_path__ + "static/media/vienna-11.c65fe0f9.jpg";